import React from 'react';
import { useLocation } from '../../hooks/useLocation';
import './LocationGuard.css';

const LocationGuard = ({ children }) => {
  const { isLoading } = useLocation();

  if (isLoading) {
    return (
      <div className="location-guard">
        <div className="location-loading">
          <div className="spinner"></div>
          <p>Checking your location...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default LocationGuard;
